import { ref, computed } from 'vue-demi';
/**
 * Toggle boolean states easily in components
 */
const useToggle = (initialValue = false) => {
    const toggle = ref(initialValue);
    const setTrue = () => {
        toggle.value = true;
    };
    const setFalse = () => {
        toggle.value = false;
    };
    const setValue = (value) => {
        toggle.value = value;
    };
    const currentValue = computed(() => {
        return toggle.value;
    });
    return {
        /**
         * Computed property getter
         * gets the current value of the boolean flag
         */
        currentValue,
        /**
         * set the boolean flag value to true
         */
        setTrue,
        /**
         * set the boolean flag value to false
         */
        setFalse,
        /**
         * Explicitly set the boolean value
         */
        setValue
    };
};
export default useToggle;
